export default __webpack_public_path__ + "static/media/footer-mobile.90dff048.jpg";